<template>
  <v-container fluid>
    <v-row>
      <!-- Panel lateral izquierdo -->
      <v-col cols="2" class="subarmario-col" v-if="armarioPrincipalSeleccionado.length > 0">
        <v-card class="pa-2" outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold">Subarmarios</v-card-title>
          <v-list dense>
            <v-list-item
              v-for="sub in obtenerSubarmariosRecursivo(armarioPrincipalSeleccionado, 1)"
              :key="sub.id"
              @click="abrirArbol(sub)"
              :class="{
                'hoverable-item': true,
                'selected-item': subarmarioSeleccionado.id === sub.id
              }"
            >
              <v-list-item-content>
                <v-list-item-title>{{ sub.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>


      <!-- Panel principal -->
      <v-col :cols="armarioPrincipalSeleccionado ? 10 : 12">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-h5 font-weight-bold">Gestión de Armarios</v-card-title>

          <!-- Crear Armario -->
          <!-- <v-form @submit.prevent="crearArmario" v-if="isRamos() || isDeveloper()" class="d-flex align-center gap mt-4">
            <v-text-field
              v-model="nuevoNombre"
              label="Nombre del armario principal"
              outlined
              dense
              hide-details
              required
              class="flex-grow-1"
            />
            <v-btn type="submit" color="primary" class="ml-2" elevation="1">
              <v-icon left>mdi-folder-plus</v-icon>
              Crear
            </v-btn>
          </v-form> -->

          <!-- Lista de Armarios -->
          <v-divider class="my-5" />
          <div v-if="armarios.length">
            <ul class="pa-0">
              <ArmarioItem
                v-for="armario in armarios"
                :key="armario.id"
                :armario="armario"
                :adjuntosVisibles="adjuntosVisibles"
                :adjuntosPorArmario="adjuntosPorArmario"
                :recorrido="recorridoArbol"
                :subarmarioSeleccionado="subarmarioSeleccionado"
                @ver-adjuntos="verAdjuntos"
                @mostrar-pdf="mostrarPDF"
                @subarmario-creado="cargarArmarios"
                @seleccionar-principal="seleccionarPrincipal"
                @eliminar-subarmario="abrirDialogoEliminarArmario"
                @editar-subarmario="abrirDialogEditarArmario"
              />
            </ul>
          </div>
          <v-alert v-else type="info" class="mt-4">
            No hay armarios creados.
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo editar subarmario -->
    <v-dialog v-model="dialogEditarArmario" max-width="400px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">Editar subarmario</v-card-title>

        <v-card-text>
          <div class="mb-2">Edita el nombre de <strong>{{ armarioAEditar?.name }}</strong>:</div>
          
          <v-text-field
            v-model="nuevoNombreArmario"
            label="Nuevo nombre"
            outlined
            dense
            required
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialogEditarArmario = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="confirmarEdicionArmario">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Diálogo de Archivos Adjuntos -->
    <v-dialog v-model="dialogoAbierto" max-width="600px">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium">Archivos adjuntos</v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item v-for="archivo in adjuntosDialog" :key="archivo.id">
              <v-list-item-content>
                <v-list-item-title class="text-body-2">
                  <v-icon small class="mr-1">mdi-paperclip</v-icon>
                  {{ archivo.name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="mostrarPDF(archivo)" :title="'Abrir archivo ' + archivo.name">
                  <v-icon color="red darken-2">mdi-download</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="abrirDialogoEliminar(archivo)"
                  :title="'Eliminar archivo ' + archivo.name"
                >
                  <v-icon color="red darken-2">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialogoAbierto = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialgo eliminar archivo -->
    <v-dialog v-model="dialogEliminarArchivo" max-width="400px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">¿Eliminar archivo?</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar <strong>{{ archivoAEliminar?.name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialogEliminarArchivo = false">Cancelar</v-btn>
          <v-btn text color="red" @click="confirmarEliminacion">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialgo eliminar subarmario -->
    <v-dialog v-model="dialogEliminarSubarmario" max-width="400px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">¿Eliminar archivo?</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar <strong>{{ armariosAEliminar[0]?.name }}</strong>?
          <!-- Mensaje adicional si tiene subarmarios -->
          <div v-if="armariosAEliminar[0]?.children?.length > 0" class="mt-2 text-caption text-red">
            También se eliminarán todos los subarmarios contenidos dentro.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialogEliminarSubarmario = false">Cancelar</v-btn>
          <v-btn text color="red" @click="confirmarEliminacionArmario">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ArmarioItem from "@/components/utils/ArmarioItem.vue"

export default {
  name: 'ArmarioCreator',
  components: { ArmarioItem },
  data() {
    return {
      nuevoNombre: '',
      armarios: [],
      adjuntosPorArmario: {},
      adjuntosVisibles: {},
      adjuntosDialog: [],
      armarioDialogId: null,
      dialogoAbierto: false,
      armarioPrincipalSeleccionado: [],
      recorridoArbol: null,
      subarmarioSeleccionado: {},

      dialogEliminarArchivo: false,
      archivoAEliminar: null,

      dialogEliminarSubarmario: false,
      armariosAEliminar:[],

      dialogEditarArmario: false,
      armarioAEditar: null,
      nuevoNombreArmario: '',  

    }
  },
  async mounted() {
    await this.cargarArmarios()
  },
  methods: {
    ...mapGetters(["isDeveloper", "isRamos"]),
    ...mapActions(['postData', 'getData', 'putData', 'deleteData']),

    async cargarArmarios() {
      const { armarios } = await this.getData({ path: 'armarios' })
      this.armarios = armarios
    },

    async crearArmario() {
      if (!this.nuevoNombre.trim()) return
      const payload = {
        name: this.nuevoNombre,
        id_parent: null
      }
      await this.postData({ path: 'armarios', body: payload })
      this.nuevoNombre = ''
      await this.cargarArmarios()
    },

    async verAdjuntos(idArmario) {
      this.armarioDialogId = idArmario
      try {
        const { adjuntos } = await this.getData({
          path: `armarios/${idArmario}/adjuntos`,
          // params: { id_armario: idArmario }
        })

        this.adjuntosPorArmario[idArmario] = adjuntos
        this.adjuntosVisibles[idArmario] = true

        this.adjuntosDialog = adjuntos.map(a => ({
          ...a,
          contenido: a.contenido,
          tipo: a.tipo || 'application/pdf',
          name: a.name || 'archivo.pdf'
        }))

        this.dialogoAbierto = true
      } catch (error) {
        console.error('Error al cargar adjuntos:', error)
        alert('No se pudieron cargar los archivos adjuntos')
      }
    },

    mostrarPDF(archivo) {
      const byteCharacters = atob(archivo.contenido)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: archivo.tipo || 'application/pdf' })
      const blobUrl = URL.createObjectURL(blob)
      window.open(blobUrl)
    },

    abrirDialogEditarArmario(armario){
      this.armarioAEditar = armario;
      this.nuevoNombreArmario = armario.name;
      this.dialogEditarArmario = true;
    },

    async confirmarEdicionArmario() {
      if (!this.nuevoNombreArmario.trim()) return;

      try {
        const payload = {
          id_armario: this.armarioAEditar.id,
          name: this.nuevoNombreArmario
        }
        // console.log(payload);
        await this.putData({ path: `armarios/${payload.id_armario}`, body: payload });

        this.dialogEditarArmario = false;
        await this.cargarArmarios(); // recargar armarios si es necesario
      } catch (error) {
        console.error("Error al editar armario", error);
      }
  },

    abrirDialogoEliminarArmario(armario){
      this.dialogEliminarSubarmario = true;
      //recogemos el listado de todos los hijos de los armarios para eliminar estos tambien
      // this.armariosAEliminar = this.obtenerSubarmariosRecursivo([armario], 2);
      this.armariosAEliminar = armario;
      // Añadir el armario principal al principio
      // this.armariosAEliminar.unshift(armario);
      // console.log(this.armariosAEliminar);
    },

    async confirmarEliminacionArmario(){
      // if (this.armariosAEliminar.length == 0) return;

      await this.eliminarArmario(this.armariosAEliminar);
      this.dialogEliminarSubarmario = false;
      this.armariosAEliminar = [];
    },

    async eliminarArmario(armarios){
      try{
        await this.deleteData({ path: `armarios/${armarios.id}` })
        await this.cargarArmarios()
      } catch(e){
        console.error("Error al eliminar armarios", e);
      }

    },

    abrirDialogoEliminar(archivo) {
      this.archivoAEliminar = archivo
      this.dialogEliminarArchivo = true
    },

    async confirmarEliminacion() {
      if (!this.archivoAEliminar) return

      await this.eliminarArchivo(this.archivoAEliminar)
      this.dialogEliminarArchivo = false
      this.archivoAEliminar = null
    },

    async eliminarArchivo(archivo) {
      try {
        await this.deleteData({ path: `armarios/adjuntos/${archivo.id}` })
        await this.verAdjuntos(this.armarioDialogId)
        await this.cargarArmarios()
      } catch (e) {
        console.error("Error al eliminar archivo")
      }
    },

    seleccionarPrincipal(id, open) {
      // this.armarioPrincipalSeleccionado = this.armarioPrincipalSeleccionado === id ? null : id
      if (open) this.armarioPrincipalSeleccionado.push(id)
      else this.armarioPrincipalSeleccionado = this.armarioPrincipalSeleccionado.filter((id_armario) => id_armario != id);
    },

    // 🚀 NUEVO: método recursivo para obtener todos los subarmarios
    obtenerSubarmariosRecursivo(idPadre, val) {
      const resultados = []

      const buscar = (nodo) => {
        if (nodo.children && nodo.children.length > 0) {
          nodo.children.forEach(hijo => {
            resultados.push(hijo)
            buscar(hijo)
          })
        }
      }

      //si val es 1, se hara la busqueda solo para armarios principales, si es 2 haremos la busqueda del armario correspondiente
      const padres = val == 1 ? this.armarios.filter(a => idPadre.includes(a.id)) : idPadre;
      // console.log(padres);
      if (padres) padres.forEach(padre => {
        buscar(padre)
      }); 

      return resultados
    },
    abrirArbol(sub){
      this.subarmarioSeleccionado = sub;

      const mapaArmarios = new Map();

      // 1. Aplanar el árbol a un mapa de id -> nodo
      const recorrer = (nodos) => {
        nodos.forEach(nodo => {
          mapaArmarios.set(nodo.id, nodo);
          if (nodo.children && nodo.children.length > 0) {
            recorrer(nodo.children);
          }
        });
      };

      recorrer(this.armarios); // ← armarios es tu array raíz

      // 2. Buscar los padres
      const resultados = [];
      let actual = mapaArmarios.get(sub.id);

      while (actual && actual.id_parent != null) {
        const padre = mapaArmarios.get(actual.id_parent);
        if (padre) {
          resultados.push(padre);
          actual = padre;
        } else {
          break;
        }
      }
      this.recorridoArbol = resultados;
    },
  }
}
</script>

<style scoped>
ul {
  list-style: none;
}
.gap {
  gap: 0.75rem;
}
.hoverable-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.hoverable-item:hover {
  background-color: #f5f5f5;
}

.selected-item {
  background-color: #e3f2fd; /* color azul claro de selección */
}
.subarmario-col {
  padding-left: 0 !important;
  margin-left: -8px; /* opcional, según tu diseño */
}

</style>
